import { Dialog, Transition } from "@headlessui/react";
import moment from "moment";
import { Fragment, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import close from "../../assets/images/icon_login/close-square.svg";
import eyeOff from "../../assets/images/icon_login/eye-off.svg";
import eye from "../../assets/images/icon_login/eye.svg";
import logoCompany from "../../assets/images/logo-company.svg";
import logo from "../../assets/images/logo-default.svg";
import { default_menu_options } from "../../config/global";
import {
  removeBalance,
  setBalance,
} from "../../core/feature/balance/balanceSlice";
import { removeCompany } from "../../core/feature/company/companySlice";
import { setCustomApp } from "../../core/feature/company/customAppsSlice";
import { setLoading } from "../../core/feature/config/configSlice";
import { useAppDispatch, useAppSelector } from "../../core/feature/hooks";
import { setLastService } from "../../core/feature/lastService/lastServiceSlice";
import {} from "../../core/feature/store";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setSwitchAccounts } from "../../core/feature/user/switchAccountSlice";
import { removeUser, setUser } from "../../core/feature/user/userSlice";
import User from "../../core/models/user";
import * as API from "../../core/service/api.js";
import * as api_balance from "../../core/service/api_balance";
import { getBroadcastData } from "../../core/service/api_notification";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
const LoginMobile = () => {
  const gaEventTracker = useAnalyticsEventTracker("External Link");

  const user: User = useAppSelector((state) => state.user.user);
  const language: String = useAppSelector((state) => state.language.language);
  const { t } = useTranslation();
  const [dataBroadcast, setDataBroadcast] = useState<any>([]);

  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [typePassword, setTypePassword] = useState("password");

  const [otherOpened, setOtherOpened] = useState(false);
  const [supportOpened, setSupportOpened] = useState(false);
  const [broadcastOpened, setBroadcastOpened] = useState(false);
  const [supportMessage, setSupportMessage] = useState("");
  const [supportUsername, setSupportUsername] = useState("");
  const [supportInstitute, setSupportInstitute] = useState("");
  const [openDetailHistory, setOpenDetailHistory] = useState(false);

  const location = useLocation();
  const stopRedirect = location.state?.stopRedirect;
  const navigate = useNavigate();
  const dispact = useAppDispatch();
  const default_menu = { ...default_menu_options };

  const login = async () => {
    var CryptoJS = require("crypto-js");
    var username = usernameRef.current?.value;
    var password = passwordRef.current?.value;
    var data = {
      username: username,
      password: password,
    };
    dispact(setLoading(true));
    API.login(data)
      .then((res) => {
        dispact(setLoading(false));

        dispact(setLastService(res.data.user.lastService));
        dispact(setToken(res.headers.authorization.replaceAll("Bearer ", "")));
        API.credentialCheck().then((resCredential) => {
          if (resCredential.data.user.accounts[0].roles.includes("ROLE_USER")) {
            if (res.data.firstLogin) {
              navigate("/confirmation-data", {
                replace: true,
                state: {
                  credential: data,
                  email: resCredential.data.user.email,
                  phone: resCredential.data.user.phone,
                },
              });
            } else {
              var auto = "1";
              var ciphertext = CryptoJS.AES.encrypt(
                JSON.stringify(data),
                "credential"
              ).toString();
              localStorage.setItem("credential", ciphertext);
              localStorage.setItem("auto_login", auto);
              dispact(setUser(resCredential.data.user));
              dispact(
                setSwitchAccounts({
                  companyName: resCredential.data.activeCompany.name,
                  companyId: resCredential.data.activeCompany.id,
                  userId: resCredential.data.user.id,
                  name: resCredential.data.user.name,
                  photoUrl: resCredential.data.user.photoUrl,
                  token: res.headers.authorization.replaceAll("Bearer ", ""),
                  lastService: res.data.user.lastService,
                })
              );
              api_balance.getBalance().then((balance) => {
                dispact(setBalance(balance.data.balance));

                if (res.data.user.lastService == "KATALIS") {
                  var languageUpper = language.toUpperCase();
                  console.log(resCredential.data.activeCompany.customApps);
                  if (resCredential.data.activeCompany.customApps) {
                    API.getCustomApps(
                      resCredential.data.activeCompany.id,
                      languageUpper
                    ).then((resCustom: any) => {
                      console.log(resCustom.data);
                      dispact(setCustomApp(resCustom.data));
                      navigate("/home", { replace: true });
                    });
                  } else {
                    default_menu.app_menu.push({
                      id: "63dfc62c31bd560297c12397",
                      menu_name: "BSI",
                      menu_path:
                        "https://bsi-burekol.dev.teknologikartu.com/Home",
                      menu_icon_url: "bsi",
                      menu_is_show: true,
                      menu_type: "URL",
                    });
                    dispact(setCustomApp(default_menu));
                    navigate("/home", { replace: true });
                  }
                } else {
                  dispact(removeUser());
                  dispact(removeBalance());
                  dispact(removeCompany());
                  toast.error(t("LOGIN.accessInvalid"));
                  navigate("/login", { replace: true });
                }
              });
            }
          } else {
            return toast.error(t("LOGIN.accessInvalid"));
          }
        });
      })
      .catch((err) => {
        dispact(setLoading(false));
        // toast.error(t("LOGIN.wrongLogin"));
      });
  };
  const funTypePassword = async () => {
    if (typePassword == "text") {
      setTypePassword("password");
    } else {
      setTypePassword("text");
    }
  };

  function openSupport() {
    setSupportOpened(true);
    setOpenDetailHistory(false);
  }

  function closeSupport() {
    setSupportOpened(false);
  }

  function openBroadcast() {
    setBroadcastOpened(true);
  }

  function closeBroadcast() {
    setBroadcastOpened(false);
  }

  function sendMessage() {
    console.log(supportMessage);
    let url = "";
    let phone = "6281326269992";
    url =
      "https://wa.me/" +
      phone +
      "?text=Halo,%20saya%20" +
      supportUsername +
      "%20dari%20" +
      supportInstitute +
      "%20menemui%20kendala%20sebagai%20berikut:%0A%0A" +
      supportMessage;
    gaEventTracker("Customer Service Visit", url);

    setSupportOpened(false);
    window.open(url, "_blank");
  }

  function funBcData() {
    console.log("getBcData");
    getBroadcastData("ACTIVE", "MOBILE").then((res) => {
      if (res.data.content.length > 0) {
        setDataBroadcast(res.data.content);
        console.log(res.data.content, "konete");
        setTimeout(() => {
          openBroadcast();
        }, 4000);
      }
    });
  }
  const getCredential = () => {
    let cred = window.localStorage.getItem("credential");
    if (cred) {
      var CryptoJS = require("crypto-js");
      var getCredential = localStorage.getItem("credential");

      var bytes = CryptoJS.AES.decrypt(getCredential, "credential");
      var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      var data = decryptedData;
      if (usernameRef.current && passwordRef.current) {
        usernameRef.current.value = data.username;
        passwordRef.current.value = data.password;
      }
    }
  };
  useEffect(() => {
    if (stopRedirect) return;
    if (user?.name) {
      navigate("/home", { replace: true });
    } else {
      funBcData();
    }
    var CryptoJS = require("crypto-js");
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify("Teserrr"),
      "password"
    ).toString();
    var bytes = CryptoJS.AES.decrypt(ciphertext, "password");
    localStorage.setItem("broadcast", "0");
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    getCredential();
  }, []);
  return (
    <>
      <div className="relative min-h-screen h-full p-10 bg-psp-primary">
        <div className="pt-24">
          <img src={logo} alt="icon" className="w-52  mx-auto" />
        </div>
        <div className="mt-10 mb-2">
          <h4 className="text-left font-semibold text-lg text-psp-primary items">
            {t("LOGIN.title")}
          </h4>
        </div>
        <div className="relative">
          <div className="flex flex-col gap-2">
            <h1 className="text-sm text-psp-gray leading-5 font-medium pl-1 mb-0">
              {t("LOGIN.username")}
            </h1>
            <input
              type="text"
              ref={usernameRef}
              className="px-3 mx-2 grow rounded-xl h-10 border-1 border-psp-border-gray border-solid"
            />
          </div>
          <div className="flex flex-col gap-2 mt-2">
            <h1 className="text-sm text-psp-gray leading-5 font-medium pl-1 mb-0">
              {t("LOGIN.password")}
            </h1>
            <div className="relative w-full flex">
              <input
                ref={passwordRef}
                type={typePassword}
                className="px-3 mx-2 grow rounded-xl h-10 border-1 border-psp-border-gray border-solid"
              />
              <img
                src={typePassword != "text" ? eyeOff : eye}
                className="font-bold text-black absolute z-10 top-2 right-5"
                onClick={() => funTypePassword()}
              />
            </div>
          </div>
          <div className="w-full mt-2 relative mb-8">
            <p
              onClick={() => {
                navigate("/forgot-password");
              }}
              className="w-fit absolute right-0 px-3 m-0  text-end font-normal text-psp-gray text-xs"
            >
              {t("LOGIN.forgotPassword")}
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={() => login()}
              className="w-full h-11 bg-psp-btn-primary shadow-sm shadow-psp-shadow p-2.5 rounded-xl text-white font-bold text-sm active:bg-psp-active"
            >
              {t("LOGIN.title")}
            </button>
            {/* <div className="flex items-center mx-2">
              <div className="flex-grow h-px bg-psp-gray"></div>

              <span className="flex-shrink text-sm text-psp-gray px-4 font-normal">
                {t("LOGIN.or")}
              </span>

              <div className="flex-grow h-px bg-psp-gray"></div>
            </div>
            <button
              className="w-full h-11 justify-center flex items-center p-2.5 rounded-xl text-psp-primary  border-psp-primary font-semibold text-sm  active:bg-gray-200"
              style={{ border: 1, borderStyle: "solid" }}
            >
              <img
                className="flex-0 "
                src={fingerprint}
                width={28}
                height={30}
              />
              <div className="grow select-none"> {t("LOGIN.fingerprint")}</div>
            </button> */}
          </div>

          <div className="w-full mt-3">
            <p className="px-3 m-0 py-2 text-center font-medium text-psp-gray text-xs">
              {t("LOGIN.help")}{" "}
              <span
                className="underline text-psp-primary italic"
                onClick={() => openSupport()}
              >
                {t("LOGIN.cs")}
              </span>
            </p>
          </div>
        </div>
        <div>
          <p
            className="text-xs font-normal mt-14 text-center"
            style={{ color: "#8F8F8F" }}
          >
            Powered By
          </p>
          <img src={logoCompany} alt="icon" className="w-28 mt-4 mx-auto" />
        </div>

        <Transition appear show={supportOpened} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={closeSupport}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-medium leading-6 text-gray-900"
                    >
                      <div>{t("CUSTOMER.title")}</div>
                    </Dialog.Title>
                    <div className="mt-2">
                      <input
                        onChange={(e) => setSupportUsername(e.target.value)}
                        placeholder={`${t("CUSTOMER.name")}`}
                        className="w-full py-1 px-2.5 rounded-lg"
                      />
                    </div>
                    <div className="mt-2">
                      <input
                        onChange={(e) => setSupportInstitute(e.target.value)}
                        placeholder={`${t("CUSTOMER.institution")}`}
                        className="w-full py-1 px-2.5 rounded-lg"
                      />
                    </div>
                    <div className="mt-2">
                      <textarea
                        onChange={(e) => setSupportMessage(e.target.value)}
                        placeholder={`${t("CUSTOMER.message")}`}
                        className="w-full py-1 px-2.5 rounded-lg"
                      ></textarea>
                    </div>
                    <div className="mt-4 flex flex-row justify-evenly">
                      <button
                        type="button"
                        className="w-full h-10 mr-1 rounded-md text-white bg-psp-btn-red"
                        onClick={closeSupport}
                      >
                        {t("CUSTOMER.no")}
                      </button>
                      <button
                        type="button"
                        className="w-full h-10 ml-1 rounded-md text-white bg-psp-btn-primary"
                        onClick={sendMessage}
                      >
                        {t("CUSTOMER.yes")}
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>

        <Transition appear show={broadcastOpened} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={closeBroadcast}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-black bg-opacity-25" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 scale-95"
                  enterTo="opacity-100 scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 scale-100"
                  leaveTo="opacity-0 scale-95"
                >
                  <Dialog.Panel className="w-full bg-white rounded-2xl max-w-md transform text-left align-middle  transition-all">
                    {dataBroadcast.map((item: any, index: any) => {
                      if (item.broadcastType === "IMAGE")
                        return (
                          <div key={index} className="w-auto h-full pb-2">
                            <Swiper
                              autoplay={true}
                              pagination={{ clickable: true, type: "fraction" }}
                              navigation={true}
                              centeredSlides={true}
                              slidesPerView={1}
                              modules={[Pagination, Navigation, Autoplay]}
                              className="flex justify-center items-center self-center relative "
                            >
                              {item.imagesFirebase.map((a: any, i: any) => {
                                return (
                                  <SwiperSlide key={i} className="">
                                    <img
                                      src={a}
                                      alt=""
                                      className="max-h-[400px] rounded-xl flex mx-auto object-fill"
                                    ></img>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                            </div>
                          </div>
                        );
                      if (item.broadcastType === "TEXT")
                        return (
                          <div key={index} className="w-full h-auto py-1">
                            <div className="flex flex-col m-3">
                              <span className="font-bold text-xl">
                                {item.title}
                              </span>
                              <span className="">{item.subtitle}</span>
                              <span className="hidden">
                                {t("BROADCAST.from")} :
                                {moment(item.startTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <span className="hidden">
                                {t("BROADCAST.until")} :
                                {moment(item.endTime).format(
                                  "DD/MM/YYYY hh:mm"
                                )}
                              </span>
                              <div className="mt-4">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: item.message,
                                  }}
                                ></span>
                              </div>
                            </div>
                          </div>
                        );
                    })}
                    <div className="absolute -bottom-6 left-0 right-0 flex flex-row">
                      <div className="flex m-auto justify-center bg-white">
                        <button
                          onClick={() => closeBroadcast()}
                          style={{
                            backgroundColor: "blue",
                          }}
                          className="active:bg-rose-700 h-8 border-0 active:border-0 focus:border-0 flex flex-row px-3 z-50 text-white -mt-10 items-center gap-2 rounded-xl"
                        >
                          <img src={close} alt="" />
                          <span className="font-bold text-sm">
                            {t("LOGIN.close")}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      </div>
    </>
  );
};

export default LoginMobile;
